import { AppMenuDto, CrudAction } from './app.model';

export const customerMenus = [
  {
    path: 'customer',
    module: 'pages',
    iconClass: 'control',
    requiredPolicy: 'Masters.Customers',
  },
  {
    path: 'prospective-customer',
    module: 'pages',
    iconClass: 'control',
    requiredPolicy: 'Masters.ProspectiveCustomers',
    crudAction: {
      read: 'pages/prospective-customer',
      create: 'pages/prospective-customer',
      update: 'pages/prospective-customer',
    },
  },
] as AppMenuDto[];
